var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"/#/perguntas-frequentes","target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t("helpers.chat.access_faq"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }